import Skeleton from '@/components/atoms/Skeleton/Skeleton';
import { useLivescoreMatch } from '@/context/LivescoreMatchContext';
import LivescoreMatchReportItem from '../LivescoreMatchReportItem/LivescoreMatchReportItem';
import LivescoreMatchAds from '../LivescoreMatchAds/LivescoreMatchAds';

const SkeletonRaport = () => {
  return (
    <>
      <div className="space-y-2">
        <Skeleton className="w-26 h-4" />
        <Skeleton className="w-full h-[160px]" />
      </div>
      <div className="space-y-2">
        <Skeleton className="w-26 h-4" />
        <Skeleton className="w-full h-[160px]" />
      </div>
    </>
  );
};

const HalfRaport = ({ index }: { index: 1 | 2 }) => {
  const { match, timeline } = useLivescoreMatch();

  return (
    <div className="space-y-2">
      <div className="w-full flex justify-between sm:text-xxs text-[7px] font-semibold text-gray-400">
        <p>{index === 1 ? 'PIERWSZA' : 'DRUGA'} POŁOWA</p>
        <p>
          {match?.sport_event_status?.period_scores?.[index - 1]?.home_score ?? '-'}:
          {match?.sport_event_status?.period_scores?.[index - 1]?.away_score ?? '-'}
        </p>
      </div>
      <ul className="text-black dark:text-white rounded-lg dark:bg-black-400 bg-white_theme-50 pl-0 border dark:border-border-400 border-gray-250 list-none min-h-[40px]">
        {timeline
          ?.filter((event) => event.period === index)
          ?.map((event) => (
            <LivescoreMatchReportItem key={event.id} event={event} />
          ))}
      </ul>
    </div>
  );
};

const LivescoreMatchRaport = () => {
  const { timeline, timelineLoading } = useLivescoreMatch();

  return (
    <div className="space-y-6">
      {timelineLoading ? (
        <SkeletonRaport />
      ) : timeline ? (
        <>
          <HalfRaport index={1} />
          <HalfRaport index={2} />
        </>
      ) : (
        <p className="text-xxs text-gray-400">Brak relacji dla tego meczu</p>
      )}
      <LivescoreMatchAds />
    </div>
  );
};

export default LivescoreMatchRaport;
